export default "__VITE_ASSET__6A36Tzui__"